<template>
  <div v-if="appearanceStore.isDrawerOpen" class="pvflex flex flex-col fill-height justify-between" style="max-width:15rem">
    <div class="grow">
      <PVMenu :model="items" class="w-full"/>
      <div class="pvflex flex flex-row flex-nowrap align-center justify-between p-4 gap-2">
        <i class="material-icons wb_sunny"/>
        <div class="grow">Dark Mode</div>
        <PVInputSwitch :value="dark" @change="appearanceStore.toggleDarkMode(!appearanceStore.isDark)"/>
      </div>
      <div v-if="false || authStore.access.superStatus" class="pvflex flex flex-row flex-nowrap align-center justify-between p-4 gap-2">
        <i class="material-icons alarm"/>
        <div class="grow">Browser Timezone</div>
        <PVInputSwitch :value="timezone" @change="preferencesStore.updateTimezone(!preferencesStore.timezone.useBrowserTime)"/>
      </div>
      <div v-if="authStore.access.superStatus && permissions">
        <PVDivider/>
        <PVButton raised class="uppercase nowrap" label="Change Permissions" severity="secondary" @click="permDialog = true"/>
        <SuperPermissionsToggleDialog v-model:visible="permDialog" class="text-center mt-4"/>
      </div>
    </div>
    <div class="shrink">
      <div class="justify-between px-2 text-center">
        <div>
          <a href="/privacy_policy">
            Privacy Policy
          </a>
        </div>
        <div>
          <a href="/terms_conditions">
            Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  </div>    
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import SuperPermissionsToggleDialog from "@/components/common/navigation/navigation/SuperPermissionsToggleDialog.vue";
import { useAppearanceStore } from '@/stores/appearance.ts';
import { usePreferencesStore } from '@/stores/preferences.ts';
import { useAuthStore } from '@/stores/authentication.ts';
import PVMenu from 'primevue/menu';
import type { MenuItem } from 'primevue/menuitem';

export default defineComponent({
  name: "NavigationDrawer",
  components: { SuperPermissionsToggleDialog, PVMenu },
  setup() {
    const appearanceStore = useAppearanceStore();
    const preferencesStore = usePreferencesStore();
    const authStore = useAuthStore();
    
    return {
      appearanceStore,
      preferencesStore,
      authStore
    };
  },
  data() {
    return {
      options: null as MenuItem[]|null,
      firstLoad: true,
      permDialog: false,      
    }
  },
  computed: {
    timezone() {
      return this.preferencesStore.timezone?.useBrowserTime ?? null;
    },
    dark() {
      return this.appearanceStore.isDark;
    },
    superAdmin() {
      return this.authStore.access.superAdmin;
    },
    permissions() {
      return this.authStore.access.permissions;
    },
    
    items() {
      let items = [];
      if (!this.options) return [];
      this.options.forEach((option) => {
        items.push({ label:option.title, icon:('material-icons ' + option.icon), route: option.route, command:()=>{ this.$router.push(option.route); } });
      });
      
      items.push({ label:'' });
      items.push({
        label:'Settings',
        icon: 'pi pi-cog',
        items:[
          { label:'Dark Mode', toggleDM:true },
          { label:'Browser Timezone', toggleBT:true },
          { label:'Change Permissions', command:()=>{ this.permDialog = true; } },
        ] });
      items.push({ label:'Privacy Policy', url:'/privacy_policy' });
      items.push({ label:'Terms & Conditions', url:'/terms_conditions' });
      
      return items;
      

    }
  },
  watch:{
    //authentication() { this.storeUpdate(); },
  },
  beforeMount() {
    //    this.storeUpdate();
    //    this.appearanceStore.$subscribe(this.storeUpdate);
    this.authStore.$subscribe(() => { this.authUpdate() });
  },
  methods: {
    togglemenu(e:MouseEvent) {
      (this.$refs.menu as any).toggle(e);
    },
    
    unauthorisedOptions() {
      return [
        {
          icon: 'email',
          title: 'Login',
          route: '/login',
        }
      ];
    },
    defaultOptions() {
      return [
        {
          icon: 'dashboard',
          title: 'Home',
          route: '/'
        },
        {
          icon: 'person',
          title: 'User',
          route: '/user'
        }
      ];
    },
    //    storeUpdate: _.debounce(function () {
    //      this.checkOptions();
    //    }, 200),
    checkOptions() {
      if (this.authStore.isLoggedIn && this.permissions) {
        let options = this.defaultOptions();
        // Now we need to add checks for each permission
        if (this.permissions.patients.view) {
          options = options.concat([
            {
              icon: 'people',
              title: 'Patients',
              route: '/patients',
              //exact: false
            }
          ]);
        }
        if (this.permissions.tags.view) {
          options = options.concat([
            {
              icon: 'devices',
              title: 'Tags',
              route: '/tags',
              //exact: false
            }
          ]);
        }
        if (this.permissions.companies.view) {
          options = options.concat([
            {
              icon: 'business',
              title: 'Companies',
              route: '/companies',
              //exact: false
            },
          ]);
        }
        if (this.permissions.monitoring.view) {
          options = options.concat([
            {
              icon: 'view_compact',
              title: 'Monitoring',
              route: '/monitoring'
            },
            {
              icon: 'view_compact',
              title: 'Monitoring (Tech)',
              route: '/monitoring2'
            },
            {
              icon: 'view_compact',
              title: 'Monitoring (Patient)',
              route: '/patientmonitoring'
            }
          ]);
        }
        if (this.authStore.access.superAdmin) {
          options = options.concat([
            {
              icon: 'new_releases',
              title: 'Test Features',
              route: '/testing',
              //exact: false
            },
            {
              icon: 'smartphone',
              title: 'App Users',
              route: '/app/users',
              //exact: false
            },
            {
              icon: 'auto_stories',
              title: 'Automated Reports',
              route: '/automated-reports',
              //exact: false
            }
          ]);
        }
        this.options = options;
      } else {
        this.options = this.unauthorisedOptions();
      }
      //      this.firstLoad = false;
    },
    authUpdate() {
      this.checkOptions();
    },
  },
});
</script>

<style scoped>

a {
    text-decoration: none !important;
}

a:visited {
    color:var(--p-form-field-color) !important;
}
a:link {
    color:var(--p-form-field-color) !important;
}

</style>
